import { config } from '../json/config'

export const isCookiePresent = (cookieName, cookieValue) => {
  const name = `${cookieName}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const cookieArray = decodedCookie.split(';')

  for (let c of cookieArray) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length) === cookieValue
    }
  }

  return false
}

export const eraseCookieFromAllPaths = name => {
  // This function will attempt to remove a cookie from all paths.

  // do a simple pathless delete first.
  document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT;`

  // remove from cookie domain
  const cookieDomain = config[window.location.hostname].cookieDomain
  document.cookie = `${name}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=${cookieDomain};`
}

export const getCookie = cname => {
  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')

  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }

  return ''
}



// WEBPACK FOOTER //
// ./src/helpers/CookieHandler.js